import { StyleSheet } from 'react-native';

import { THEME } from 'reactor/common';

const { COLOR } = THEME;

export default StyleSheet.create({
  container: {
    backgroundColor: COLOR.BACKGROUND,
    height: '100vh',
    width: '100vw',
  },
});
